export const manage = {
  manageFlowPara: 'Edit and rename the configuration template of your choice',
  version: 'Version',
  name: 'Name',
  code: 'Code',
  createdBy: 'Author',
  modelUnitConversion: 'Model unit conversion',
  dimensionModeEnabledInfo:
    'Switch enabled: lengths are taken default value. The model unit conversion field is inactive in this mode.',
  dimensionModeDisabledInfo:
    'Switch disabled: you can manually define the model unit conversion used for scene length and related calculations.',
  dimensionModeEditInfo:
    'Scene length unit and conversion can be changed only for draft flows and with EDIT permission.',
  criteriaSummaryDescription:
    'Check the selected criteria and confirm the changes.',
  savedSuccess: 'Changes saved',
  criterionIssue: {
    deleted: 'The criterion has been deleted and can no longer be used',
    inactive:
      'This option is inactive, the template can be saved but not published',
  },
}
